(function () {
  'use strict';

  var wrapper      = document.getElementById('ls-mini-cart');
  if (!wrapper) return;

  var toggleBtn    = document.querySelector('[data-ls-cart-toggle]');
  var overlay      = document.getElementById('ls-cart-overlay');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  // ── open / close ──────────────────────────────────────────────
  function open(fromAtc) {
    /* on desktop (>1400px), scroll to top so the popup is always in view */
    if (fromAtc && window.scrollY > 50 && window.matchMedia('(min-width: 1401px)').matches) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    wrapper.classList.add('is-open');
    wrapper.setAttribute('aria-hidden', 'false');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    if (overlay)   overlay.classList.add('is-active');
  }

  function close() {
    wrapper.classList.remove('is-open');
    wrapper.setAttribute('aria-hidden', 'true');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    if (overlay)   overlay.classList.remove('is-active');
  }

  function toggle() {
    wrapper.classList.contains('is-open') ? close() : open();
  }

  // ── count badge ───────────────────────────────────────────────
  function updateCount(n) {
    cartCountEls.forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  // ── re-render ─────────────────────────────────────────────────
  function rerender(openAfter) {
    return fetch('/cart?section_id=mini-cart', {
      credentials: 'same-origin',
      headers: { 'Cache-Control': 'no-cache' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newCart = tmp.querySelector('.mini-cart');
        var count   = 0;

        if (newCart) {
          count = parseInt(newCart.getAttribute('data-item-count') || '0', 10);
          var curCart = wrapper.querySelector('.mini-cart');
          if (curCart) {
            curCart.innerHTML = newCart.innerHTML;
            curCart.setAttribute('data-item-count', count);
          }
        }

        updateCount(count);
        document.dispatchEvent(new CustomEvent('cart:rerendered'));

        if (openAfter) open(true);
      })
      .catch(function (e) { console.error('[ls-cart] rerender failed', e); });
  }

  // ── quantity change ───────────────────────────────────────────
  function changeQty(line, quantity) {
    fetch(window.routes.cartChangeUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { return rerender(false); })
      .catch(function (e) { console.error('[ls-cart] qty change failed', e); });
  }

  // ── cart click handler ────────────────────────────────────────
  function onCartClick(e) {
    var btn = e.target.closest('[data-action="increase-quantity"],[data-action="decrease-quantity"]');
    if (btn) {
      e.preventDefault();
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var qty  = parseInt(btn.getAttribute('data-quantity'), 10);
      if (!isNaN(line) && !isNaN(qty)) changeQty(line, qty);
      return;
    }
    if (e.target.closest('[data-action="toggle-mini-cart"]')) {
      e.preventDefault();
      close();
    }
  }

  // ── event listeners ───────────────────────────────────────────
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      toggle();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', close);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wrapper.classList.contains('is-open')) close();
  });

  wrapper.addEventListener('click', onCartClick);

  document.addEventListener('product:added', function () {
    var isMobile = window.matchMedia('(max-width: 999px)').matches;
    rerender(!isMobile);
  });

  // Silent cart resync — used after a rejected add to keep count badge accurate
  document.addEventListener('cart:sync', function () {
    rerender(false);
  });

  // On mobile: suppress the Warehouse drawer on non-cart pages.
  // Cart page: leave cartType as Warehouse's default so its AJAX + reload
  // quantity handler works the same as desktop. Setting 'page' here broke
  // the quantity +/- buttons by switching to href navigation which didn't fire.
  document.addEventListener('DOMContentLoaded', function () {
    if (window.matchMedia('(max-width: 999px)').matches && window.theme) {
      if (window.theme.pageType !== 'cart') {
        window.theme.cartType = 'silent';
      }
    }
  });
})();
